import 'whatwg-fetch'
import PouchDB from 'pouchdb-core'
import http from 'pouchdb-adapter-http'
import mapreduce from 'pouchdb-mapreduce'
import upsert from 'pouchdb-upsert'

PouchDB.plugin(http)
PouchDB.plugin(mapreduce)
PouchDB.plugin(upsert)

const { VUE_APP_COUCHDB_URL } = process.env

export const PREFIX = VUE_APP_COUCHDB_URL ? `${VUE_APP_COUCHDB_URL}/` : ''
const OPTIONS = VUE_APP_COUCHDB_URL ? { skipSetup: true, ajax: { timeout: 120000 } } : {}

export const bogs = new PouchDB(`${PREFIX}bogs`, OPTIONS)
export const ads = new PouchDB(`${PREFIX}ads`, OPTIONS)
